import {
  dimensiondata_1_fogyasztasi_sav_group_w300_row,
  dimensiondata_2_adozasi_szint_group_column,
  halfYear_row_expanded,
  huf_kilowatt_ora_value_1_data_precision_no_year_half_year_summary,
  year_row_expanded,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const villamosLakossagiArakConfig: PivotGridConfig = {
  showChart: false,
  filterYear: {},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/VillamosLakossagiArak',
      select: ['date', 'dimension_1', 'dimension_2', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      year_row_expanded,
      halfYear_row_expanded,
      ...dimensiondata_1_fogyasztasi_sav_group_w300_row,
      ...dimensiondata_2_adozasi_szint_group_column,
      huf_kilowatt_ora_value_1_data_precision_no_year_half_year_summary,
      order_1,
      order_2
    ],
  },
};
